const SAME_ORIGIN_BASE = 'http://internal-path.invalid';

export function toSafeInternalPath(value?: string | null, fallback = '/'): string {
  if (!value || !value.startsWith('/')) {
    return fallback;
  }

  try {
    const url = new URL(value, SAME_ORIGIN_BASE);

    const isInternal = url.origin === SAME_ORIGIN_BASE && !url.pathname.startsWith('//');

    return isInternal ? `${url.pathname}${url.search}${url.hash}` : fallback;
  } catch {
    return fallback;
  }
}
